import { Shimmer } from '@components';

export const AffectedItemsDialogLoading = () => {
  return (
    <>
      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
          marginTop: 8,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
          marginTop: 8,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 48,
          width: '100%',
          borderRadius: 8,
          marginTop: 8,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </>
  );
};
